import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/autocomplete/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/badge/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/breadcrumbs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/calendar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/date-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/date-picker/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/dropdown/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ResizablePanel"] */ "/app/node_modules/@nextui-org/framer-utils/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/listbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/navbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/pagination/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/ripple/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/scroll-shadow/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/skeleton/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/snippet/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/user/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/[lang]/mijn-mkg/(with_tracking)/layout.jsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../../../../fonts/Futura_PT_Book.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../../../../fonts/Futura_PT_Bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../../../../../fonts/Futura_PT_ExtraBold.woff2\",\"weight\":\"800\",\"style\":\"normal\"},{\"path\":\"../../../../../fonts/Futura_PT_Light.woff2\",\"weight\":\"200\",\"style\":\"normal\"}],\"display\":\"swap\"}],\"variableName\":\"myFont\"}");
;
import(/* webpackMode: "eager" */ "/app/public/images/MKG-logo-2024_Menu_w172pxXh50px_full-color.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BreadCrumbs/BreadCrumbs.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugsnagClient"] */ "/app/src/components/BugsnagClient/BugsnagClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropDown"] */ "/app/src/components/DropDown/DropDown.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/FooterDropdown.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LoadingBar/LoadingBar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GebruikerDropDown"] */ "/app/src/components/Menu/components/GebruikerDorpDownBtns.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Menu/components/HamburgerOverlayMenu.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Menu/components/mijnmkgsubmenu.module.scss");
;
import(/* webpackMode: "eager" */ "/app/sass/app.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Menu/components/MijnMkgSubMenuClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Menu/components/ShowTekstPaden.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Menu/menu.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MkgMenuClientSide"] */ "/app/src/components/Menu/MkgMenuClientSide.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchBar/SearchBar.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/hooks/useSessionClient.jsx");
